
/* injects from baggage-loader */

'use strict';

import ModerateCommentModalController from './moderatecommentmodal.controller';
import ModerateCommentModalTemplate from './moderatecommentmodal.html';

export default class ModerateCommentModalComponent {
		constructor() {
				this.templateUrl = ModerateCommentModalTemplate;
				this.controller = ModerateCommentModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
